/* eslint-disable react-hooks/exhaustive-deps */
import React, { useContext, useEffect, useRef, useState, useMemo, useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Container } from 'react-bootstrap';
import { MultiSelect } from 'react-multi-select-component';
import { useDispatch, useSelector } from 'react-redux';
import { cloneDeep, isEmpty } from 'lodash';
import { useParams } from 'react-router-dom';
import { Typeahead } from 'react-bootstrap-typeahead';
import 'react-bootstrap-typeahead/css/Typeahead.css';
import { CareUserContext } from './provider/careUserContext';
import { customStylesProductAddEdit } from '../../../Components/helper';
import UserLibraryFilter from './UserLibraryFilter';
import * as action from './store/UserInstruction.action';
import CommonAccordion from './commonAccordion';
import DragDropSort from '../../../Components/DragDropSort/DragDropSort';
import ConfirmationPopup from '../../../Components/ModalPopup/ConfirmationPopup';
import { toasterMsg } from '../../../Components/Toaster/Toaster';
import * as systemMasterAction from '../../SystemMasters/Store/SystemMasters.action';

export default function AddEditCareUserGroup() {
  const { t } = useTranslation('common');
  const { state, setState, getUserInstructionType } = useContext(CareUserContext);
  const dispatch = useDispatch();
  const { groupId } = useParams();

  const typeaheadRef = useRef(null);
  const reducer = useSelector((reducerstate) => reducerstate);
  const {
    UserInstructionDetails: { careLibraries, existingCareGrpCombination },
    UserDetails: { userInfo },
    SystemMastersDetails: { brandList, category1List, category2List, category3List, category4List, pcTypeList, multiSubBrandList },
  } = reducer;
  const [suggestionList, setSuggestionList] = useState([]);
  const [subBrandAccess, setSubBrandAccess] = useState(false);
  const [catBasedOnPTData, setCatBasedOnPTData] = useState(false);

  const brandOptions = useMemo(() => {
    if (brandList?.length > 0) {
      return brandList.map((item) => ({
        label: item.name,
        value: item._id,
      }));
    }
  }, [brandList]);

  const subBrandOptions = useMemo(() => {
    if (multiSubBrandList?.length > 0) {
      return multiSubBrandList.map((item) => ({
        isActive: item.isActive,
        label: item.name,
        value: item._id,
        brandId: item.brandId,
      }));
    }
  }, [multiSubBrandList]);

  const category1Options = useMemo(() => {
    if (category1List?.length > 0) {
      return category1List.map((item) => ({
        label: item.name,
        value: item._id,
        _raw: item,
      }));
    }
  }, [category1List]);

  const category2Options = useMemo(() => {
    if (category2List?.length > 0) {
      return category2List.map((item) => ({
        label: item.name,
        value: item._id,
        _raw: item,
      }));
    }
  }, [category2List]);

  const category3Options = useMemo(() => {
    if (category3List?.length > 0) {
      return category3List.map((item) => ({
        label: item.name,
        value: item._id,
        _raw: item,
      }));
    }
  }, [category3List]);

  const category4Options = useMemo(() => {
    if (category4List?.length > 0) {
      return category4List.map((item) => ({
        label: item.name,
        value: item._id,
        _raw: item,
      }));
    }
  }, [category4List]);

  const pcTypeOptions = useMemo(() => {
    if (pcTypeList?.length > 0) {
      return pcTypeList.map((item) => ({
        label: item.name,
        value: item._id,
      }));
    }
  }, [pcTypeList]);

  const hideShowDragDrop = () => {
    setState((prevState) => ({
      ...prevState,
      showDragDrop: !state?.showDragDrop,
    }));
  };
  const handleSaveSequence = async (_e, sequenceList) => {
    setState((prevState) => ({
      ...prevState,
      careGroupDetails: {
        ...prevState.careGroupDetails,
        tabs: sequenceList?.sequence, // Assign sequenceList.sequence to tabs
      },
    }));
    hideShowDragDrop();
  };

  useEffect(() => {
    if (state?.careGroupDetails?.isRequired) {
      dispatch(action.checkUniqueProductType(state?.careGroupDetails?.isRequired || false));
    }
  }, [state?.careGroupDetails?.isRequired]);

  useEffect(() => {
    const fetchSubBrandAccess = async () => {
      const subBrandAccessRes = await dispatch(systemMasterAction.getSubBrandAccess());
      setSubBrandAccess(subBrandAccessRes?.data || false);
    };
    fetchSubBrandAccess();
  }, [dispatch]);

  useEffect(() => {
    if (!isEmpty(state?.careGroupDetails?.brandIds)) {
      dispatch(systemMasterAction.getMultiSubBrandDetails({ brandId: state?.careGroupDetails?.brandIds?.map((item) => item.value) }));
    }
  }, [state?.careGroupDetails?.brandIds, dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      /* groupId make sures it is getting modified, passing !!groupId will send 
      truthy value for and checks if all product types needs to be displayed */
      await Promise.all([dispatch(action.getCareLibraries()), dispatch(action.getAllColumns())]);
      if (groupId) {
        dispatch(action.fetchGroupUserInstructionsDetailsAction({ id: groupId }));
      } else {
        await dispatch(action.clearTabReducer());
        await getUserInstructionType();
      }
    };
    fetchData();
    const init = async () => {
      try {
        await Promise.all([
          dispatch(
            systemMasterAction.getBrandDetails({
              loggedInUserId: userInfo?.userId,
              isActive: 1,
            }),
          ),
          dispatch(
            systemMasterAction.getPCTypesDetails({
              loggedInUserId: userInfo?.userId,
              isActive: true,
              tier: 'Tier1',
            }),
          ),
          dispatch(
            systemMasterAction.getCategory1Details({
              categoryType: 1,
              loggedInUserId: userInfo?.userId,
              isActive: true,
            }),
          ),
          dispatch(
            systemMasterAction.getCategory2Details({
              categoryType: 2,
              loggedInUserId: userInfo?.userId,
              isActive: true,
            }),
          ),
        ]);
      } catch (e) {
        console.log('Error:', e);
      }
    };

    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch]);

  useEffect(() => {
    const fetchCatBasedOnPTData = async () => {
      try {
        const res = await dispatch(systemMasterAction.getCatBasedOnPT());
        setCatBasedOnPTData(!!res);
      } catch (e) {
        setCatBasedOnPTData(false);
      }
    };
    fetchCatBasedOnPTData();
  }, [dispatch]);

  const handleInput = (value, key) => {
    const newData = cloneDeep(state?.careGroupDetails);
    newData[key] = value;
    setState((prevState) => ({
      ...prevState,
      careGroupDetails: newData,
    }));
  };

  const keysToCheck = ['productType', 'brandIds', 'catOneIds', 'catTwoIds', 'catThreeIds', 'catFourIds'];

  const findMatchingNames = (existingData, localState) => {
    const filteredData = existingData?.filter((item) => item?._id !== groupId);
    // Only return names

    return filteredData
      ?.filter((item) => {
        // Every key must have at least one matching value
        return keysToCheck.every((key) => {
          const existingValues = item[key]?.map((obj) => obj.value) || [];
          const localValues = localState[key]?.map((obj) => obj.value) || [];

          // If local has no values but existing has, it's a mismatch
          if (localValues.length === 0 && existingValues.length > 0) return false;

          // If both are empty, consider it a match
          if (localValues.length === 0 && existingValues.length === 0) return true;

          // Must have at least one common value
          return localValues.some((value) => existingValues.includes(value));
        });
      })
      .map((item) => item.name);
  };

  // Check unique Product Type, Brand, Category 1, Category 2, Category 3, Category 4
  useEffect(() => {
    if (existingCareGrpCombination?.length > 0 && state?.careGroupDetails?.isRequired) {
      const matchingNames = findMatchingNames(existingCareGrpCombination, state?.careGroupDetails);
      if (matchingNames.length > 0) {
        setState((prevState) => ({
          ...prevState,
          careGroupDetails: {
            ...prevState.careGroupDetails,
            isSaveDisable: true,
          },
        }));
        toasterMsg(`${matchingNames.join(', ')}${t('CARE_LABELS.GROUP.ADD_EDIT.UNIQUE_GROUP')}`, 'danger');
      } else {
        setState((prevState) => ({
          ...prevState,
          careGroupDetails: {
            ...prevState.careGroupDetails,
            isSaveDisable: false,
          },
        }));
      }
    }
  }, [
    existingCareGrpCombination,
    state?.careGroupDetails?.productType,
    state?.careGroupDetails?.brandIds,
    state?.careGroupDetails?.catOneIds,
    state?.careGroupDetails?.catTwoIds,
    state?.careGroupDetails?.catThreeIds,
    state?.careGroupDetails?.catFourIds,
  ]);

  useEffect(() => {
    if (careLibraries?.columns?.length > 0 && careLibraries?.rows?.length > 0) {
      const codeColumnId = careLibraries?.columns
        .map((col) => {
          if (col?.name === 'Code') return col?._id;
        })
        .filter((ele) => ele !== undefined);

      const descriptionColumnId = careLibraries?.columns
        .map((col) => {
          if (col?.name === 'Description') return col?._id;
        })
        .filter((ele) => ele !== undefined);

      const codeRows = careLibraries?.rows?.filter((row) => codeColumnId.includes(row.columnId.toString()));
      const descriptionRows = careLibraries?.rows?.filter((row) => descriptionColumnId.includes(row.columnId.toString()));
      const filteredRows = [...codeRows, ...descriptionRows];

      // Merge rows with the same rowId.
      const mergedRows = filteredRows
        .reduce((acc, row) => {
          const existing = acc.find((item) => item.rowId === row.rowId);
          let newValueKey;
          let columnKey;

          if (codeColumnId.includes(row.columnId.toString())) {
            newValueKey = 'code';
            columnKey = 'codeId';
          } else if (descriptionColumnId.includes(row.columnId.toString())) {
            newValueKey = 'description';
            columnKey = 'descriptionId';
          } else {
            newValueKey = 'value';
          }

          if (existing) {
            // If a row with the same rowId already exists, add the new field and columnId.
            existing[newValueKey] = row.value || ''; // Ensure a default value for code or description.
            if (columnKey) {
              existing[columnKey] = row.columnId;
            }
          } else {
            // Otherwise, add a new entry.
            acc.push({
              ...row,
              [newValueKey]: row.value || '', // Ensure a default value for code or description.
              ...(columnKey ? { [columnKey]: row.columnId } : {}),
            });
          }

          return acc;
        }, [])
        .map((item) => ({
          ...item,
          code: item.code || '', // Ensure `code` is always a string.
          description: item.description || '', // Ensure `description` is always a string.
        }));

      // Ensure suggestion list has valid code strings
      setSuggestionList(
        mergedRows.filter(
          (item) => (typeof item.code === 'string' && item.code.trim() !== '') || (typeof item.description === 'string' && item.description.trim() !== ''),
        ),
      );
    }
  }, [careLibraries]);

  // Custom filter function to search in both code and description
  const customFilterBy = useCallback((option, data) => {
    const searchText = data?.text?.toLowerCase();
    const code = (option.code || '')?.toLowerCase();
    const description = (option.description || '')?.toLowerCase();

    return code?.includes(searchText) || description?.includes(searchText);
  }, []);

  const onAutoSuggestion = (suggestion) => {
    if (suggestion?.length > 0) {
      typeaheadRef.current.clear();
      const data = cloneDeep(state?.careGroupDetails);

      const isRowIdPresent = data?.tabs?.some((tab) => tab?.tabDetails?.some((detail) => detail?.rowId === suggestion[0]?.rowId));

      if (isRowIdPresent) {
        toasterMsg(t('CARE_LABELS.GROUP.ADD_EDIT.SELECTED_CARE_LABEL_COMPONENT'), 'danger');
      } else {
        const tabColumns = careLibraries?.columns?.filter((col) => col.tabId === suggestion[0]?.tabId);
        const tabRows = careLibraries?.rows?.filter((row) => row.rowId === suggestion[0]?.rowId && row.tabId === suggestion[0]?.tabId);
        data.tabs = data?.tabs?.map((tab) => {
          // Check if the tabId matches the selected suggestion
          if (tab.tabId === suggestion[0]?.tabId) {
            return {
              ...tab,
              tabColumns,
              tabDetails: [...(tab.tabDetails || []), ...tabRows], // Push the suggestion into tabDetails
            };
          }
          return tab;
        });

        setState((prevState) => ({
          ...prevState,
          careGroupDetails: data,
        }));
      }
    }
  };

  const getCategory3Data = (cat1, cat2) => {
    if (cat1 && cat2) {
      dispatch(
        systemMasterAction.getCategory3Details({
          categoryOneId: cat1,
          categoryTwoId: cat2,
          categoryType: 3,
          isActive: true,
          loggedInUserId: userInfo?.userId,
        }),
      );
    }
  };

  const getCategory4Data = (cat1, cat2, cat3) => {
    if (cat1 && cat2 && cat3) {
      dispatch(
        systemMasterAction.getCategory4Details({
          categoryOneId: cat1,
          categoryTwoId: cat2,
          categoryThreeId: cat3,
          categoryType: 4,
          isActive: true,
          loggedInUserId: userInfo?.userId,
        }),
      );
    }
  };

  // Call Category 3 API on initial render
  useEffect(() => {
    if (state?.careGroupDetails?.catOneIds?.length > 0 && state?.careGroupDetails?.catTwoIds?.length > 0) {
      const catOneIds = state?.careGroupDetails?.catOneIds?.map((item) => item.value);
      const catTwoIds = state?.careGroupDetails?.catTwoIds?.map((item) => item.value);
      getCategory3Data(catOneIds, catTwoIds);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.careGroupDetails?.catOneIds, state?.careGroupDetails?.catTwoIds]);

  // Derived cascading options based on flag and selections
  const selectedPTIds = useMemo(() => state?.careGroupDetails?.productType?.map((p) => p?.value) || [], [state?.careGroupDetails?.productType]);
  const selectedCat1Ids = useMemo(() => state?.careGroupDetails?.catOneIds?.map((c) => c?.value) || [], [state?.careGroupDetails?.catOneIds]);
  const selectedCat2Ids = useMemo(() => state?.careGroupDetails?.catTwoIds?.map((c) => c?.value) || [], [state?.careGroupDetails?.catTwoIds]);
  const selectedCat3Ids = useMemo(() => state?.careGroupDetails?.catThreeIds?.map((c) => c?.value) || [], [state?.careGroupDetails?.catThreeIds]);

  const category1OptionsDerived = useMemo(() => {
    const base = category1Options || [];
    if (!catBasedOnPTData) return base;
    if (!selectedPTIds?.length) return [];
    return base.filter((opt) => {
      const pts = opt?._raw?.productType || [];
      const ptIds = Array.isArray(pts) ? pts.map((pt) => pt?._id || pt) : [];
      return ptIds?.some((id) => selectedPTIds?.includes(id));
    });
  }, [category1Options, catBasedOnPTData, selectedPTIds]);

  const category2OptionsDerived = useMemo(() => {
    const base = category2Options || [];
    if (!catBasedOnPTData) return base;
    if (!selectedPTIds?.length) return [];
    if (!selectedCat1Ids?.length) return [];
    return base.filter((opt) => {
      const rel = opt?._raw?.categoryOneId || opt?._raw?.catOneIds || [];
      const arr = Array.isArray(rel) ? rel : [rel];
      const relIds = arr.map((r) => r?._id || r).filter(Boolean);
      return relIds?.some((id) => selectedCat1Ids?.includes(id));
    });
  }, [category2Options, catBasedOnPTData, selectedPTIds, selectedCat1Ids]);

  const category3OptionsDerived = useMemo(() => {
    const base = category3Options || [];
    if (!catBasedOnPTData) return base;
    if (!selectedCat1Ids?.length || !selectedCat2Ids?.length) return [];
    return base.filter((opt) => {
      const c1Rel = opt?._raw?.categoryOneId || opt?._raw?.catOneIds || [];
      const c2Rel = opt?._raw?.categoryTwoId || opt?._raw?.catTwoIds || [];
      const a1 = (Array.isArray(c1Rel) ? c1Rel : [c1Rel]).map((r) => r?._id || r).filter(Boolean);
      const a2 = (Array.isArray(c2Rel) ? c2Rel : [c2Rel]).map((r) => r?._id || r).filter(Boolean);
      return a1?.some((id) => selectedCat1Ids?.includes(id)) && a2?.some((id) => selectedCat2Ids?.includes(id));
    });
  }, [category3Options, catBasedOnPTData, selectedCat1Ids, selectedCat2Ids]);

  const category4OptionsDerived = useMemo(() => {
    const base = category4Options || [];
    if (!catBasedOnPTData) return base;
    if (!selectedCat1Ids?.length || !selectedCat2Ids?.length || !selectedCat3Ids?.length) return [];
    return base.filter((opt) => {
      const c1Rel = opt?._raw?.categoryOneId || opt?._raw?.catOneIds || [];
      const c2Rel = opt?._raw?.categoryTwoId || opt?._raw?.catTwoIds || [];
      const c3Rel = opt?._raw?.categoryThreeId || opt?._raw?.catThreeIds || [];
      const a1 = (Array.isArray(c1Rel) ? c1Rel : [c1Rel]).map((r) => r?._id || r).filter(Boolean);
      const a2 = (Array.isArray(c2Rel) ? c2Rel : [c2Rel]).map((r) => r?._id || r).filter(Boolean);
      const a3 = (Array.isArray(c3Rel) ? c3Rel : [c3Rel]).map((r) => r?._id || r).filter(Boolean);
      return (
        a1?.some((id) => selectedCat1Ids?.includes(id)) && a2?.some((id) => selectedCat2Ids?.includes(id)) && a3?.some((id) => selectedCat3Ids?.includes(id))
      );
    });
  }, [category4Options, catBasedOnPTData, selectedCat1Ids, selectedCat2Ids, selectedCat3Ids]);

  const handleMultiSelect = (selected, key) => {
    // Handle brand-subbrand relationship
    if (key === 'brandIds') {
      const selectedBrandIds = selected?.map((item) => item.value);
      const currentSubBrands = state?.careGroupDetails?.subBrandIds || [];

      // Only keep sub-brands that belong to selected brands
      const validSubBrands =
        currentSubBrands?.filter((subBrand) => {
          const subBrandData = multiSubBrandList?.find((sb) => sb._id === subBrand.value);
          return subBrandData && selectedBrandIds?.includes(subBrandData.brandId);
        }) || [];

      // Update both brand and sub-brand selections
      const newData = cloneDeep(state?.careGroupDetails);
      newData[key] = selected;
      newData.subBrandIds = validSubBrands;
      setState((prevState) => ({
        ...prevState,
        careGroupDetails: newData,
      }));
    } else {
      handleInput(selected, key);
    }

    const selectedIds = selected?.map((item) => item.value);
    switch (key) {
      case 'productType':
        if (catBasedOnPTData) {
          // When flag is ON: k valid under the new Product Type set
          const newPTIds = (selected || []).map((it) => it?.value);

          // Allowed Category 1 options for new PT
          const allowedCat1Ids = (category1Options || [])
            .filter((opt) => {
              const pts = opt?._raw?.productType || [];
              const ptIds = Array.isArray(pts) ? pts.map((pt) => pt?._id || pt) : [];
              return ptIds?.some((id) => newPTIds?.includes(id));
            })
            .map((opt) => opt?.value);

          setState((prev) => {
            const prevDetails = prev?.careGroupDetails || {};
            // Keep Cat1 that are still allowed
            const keptCatOne = (prevDetails?.catOneIds || []).filter((it) => allowedCat1Ids?.includes(it?.value));

            // Allowed Cat2 based on kept Cat1
            const keptC1Vals = keptCatOne.map((k) => k?.value);
            const allowedCat2Ids = (category2Options || [])
              .filter((opt) => {
                const rel = opt?._raw?.categoryOneId || opt?._raw?.catOneIds || [];
                const arr = Array.isArray(rel) ? rel : [rel];
                const relIds = arr.map((r) => r?._id || r).filter(Boolean);
                return relIds?.some((id) => keptC1Vals?.includes(id));
              })
              .map((opt) => opt?.value);
            const keptCatTwo = (prevDetails?.catTwoIds || []).filter((it) => allowedCat2Ids?.includes(it?.value));

            // Allowed Cat3 based on kept Cat1 & Cat2
            const keptC2Vals = keptCatTwo.map((k) => k?.value);
            const allowedCat3Ids = (category3Options || [])
              .filter((opt) => {
                const c1Rel = opt?._raw?.categoryOneId || opt?._raw?.catOneIds || [];
                const c2Rel = opt?._raw?.categoryTwoId || opt?._raw?.catTwoIds || [];
                const a1 = (Array.isArray(c1Rel) ? c1Rel : [c1Rel]).map((r) => r?._id || r).filter(Boolean);
                const a2 = (Array.isArray(c2Rel) ? c2Rel : [c2Rel]).map((r) => r?._id || r).filter(Boolean);
                return a1?.some((id) => keptC1Vals?.includes(id)) && a2?.some((id) => keptC2Vals?.includes(id));
              })
              .map((opt) => opt?.value);
            const keptCatThree = (prevDetails?.catThreeIds || []).filter((it) => allowedCat3Ids?.includes(it?.value));

            // Allowed Cat4 based on kept Cat1, Cat2 & Cat3
            const keptC3Vals = keptCatThree.map((k) => k?.value);
            const allowedCat4Ids = (category4Options || [])
              .filter((opt) => {
                const c1Rel = opt?._raw?.categoryOneId || opt?._raw?.catOneIds || [];
                const c2Rel = opt?._raw?.categoryTwoId || opt?._raw?.catTwoIds || [];
                const c3Rel = opt?._raw?.categoryThreeId || opt?._raw?.catThreeIds || [];
                const a1 = (Array.isArray(c1Rel) ? c1Rel : [c1Rel]).map((r) => r?._id || r).filter(Boolean);
                const a2 = (Array.isArray(c2Rel) ? c2Rel : [c2Rel]).map((r) => r?._id || r).filter(Boolean);
                const a3 = (Array.isArray(c3Rel) ? c3Rel : [c3Rel]).map((r) => r?._id || r).filter(Boolean);
                return a1?.some((id) => keptC1Vals?.includes(id)) && a2?.some((id) => keptC2Vals?.includes(id)) && a3?.some((id) => keptC3Vals?.includes(id));
              })
              .map((opt) => opt?.value);
            const keptCatFour = (prevDetails?.catFourIds || []).filter((it) => allowedCat4Ids?.includes(it?.value));

            return {
              ...prev,
              careGroupDetails: {
                ...prevDetails,
                productType: selected,
                catOneIds: keptCatOne,
                catTwoIds: keptCatTwo,
                catThreeIds: keptCatThree,
                catFourIds: keptCatFour,
              },
            };
          });
        }
        break;
      case 'catOneIds':
        {
          const catTwoIds = state?.careGroupDetails?.catTwoIds?.map((item) => item.value);
          getCategory3Data(selectedIds, catTwoIds);
          if (catBasedOnPTData) {
            const prevC1 = state?.careGroupDetails?.catOneIds || [];
            const prevC1Len = prevC1.length;
            const isAdding = (selectedIds?.length || 0) >= prevC1Len;
            if (isAdding) {
              // Adding Cat1: keep existing Cat2/3/4 as-is
              setState((prev) => ({
                ...prev,
                careGroupDetails: {
                  ...prev?.careGroupDetails,
                  catOneIds: selected,
                },
              }));
              break;
            }
            // Removing Cat1: prune Cat2/3/4 based on new Cat1 selection (selectedIds)
            const keptC1Vals = selectedIds || [];

            const allowedCat2Ids = (category2Options || [])
              .filter((opt) => {
                const rel = opt?._raw?.categoryOneId || opt?._raw?.catOneIds || [];
                const arr = Array.isArray(rel) ? rel : [rel];
                const relIds = arr.map((r) => r?._id || r).filter(Boolean);
                return relIds?.some((id) => keptC1Vals?.includes(id));
              })
              .map((opt) => opt?.value);

            const prevCatTwo = state?.careGroupDetails?.catTwoIds || [];
            const keptCatTwo = prevCatTwo.filter((it) => allowedCat2Ids?.includes(it?.value));
            const keptC2Vals = keptCatTwo.map((k) => k?.value);

            const allowedCat3Ids = (category3Options || [])
              .filter((opt) => {
                const c1Rel = opt?._raw?.categoryOneId || opt?._raw?.catOneIds || [];
                const c2Rel = opt?._raw?.categoryTwoId || opt?._raw?.catTwoIds || [];
                const a1 = (Array.isArray(c1Rel) ? c1Rel : [c1Rel]).map((r) => r?._id || r).filter(Boolean);
                const a2 = (Array.isArray(c2Rel) ? c2Rel : [c2Rel]).map((r) => r?._id || r).filter(Boolean);
                return a1?.some((id) => keptC1Vals?.includes(id)) && a2?.some((id) => keptC2Vals?.includes(id));
              })
              .map((opt) => opt?.value);
            const prevCatThree = state?.careGroupDetails?.catThreeIds || [];
            const keptCatThree = prevCatThree.filter((it) => allowedCat3Ids?.includes(it?.value));
            const keptC3Vals = keptCatThree.map((k) => k?.value);

            const allowedCat4Ids = (category4Options || [])
              .filter((opt) => {
                const c1Rel = opt?._raw?.categoryOneId || opt?._raw?.catOneIds || [];
                const c2Rel = opt?._raw?.categoryTwoId || opt?._raw?.catTwoIds || [];
                const c3Rel = opt?._raw?.categoryThreeId || opt?._raw?.catThreeIds || [];
                const a1 = (Array.isArray(c1Rel) ? c1Rel : [c1Rel]).map((r) => r?._id || r).filter(Boolean);
                const a2 = (Array.isArray(c2Rel) ? c2Rel : [c2Rel]).map((r) => r?._id || r).filter(Boolean);
                const a3 = (Array.isArray(c3Rel) ? c3Rel : [c3Rel]).map((r) => r?._id || r).filter(Boolean);
                return a1?.some((id) => keptC1Vals?.includes(id)) && a2?.some((id) => keptC2Vals?.includes(id)) && a3?.some((id) => keptC3Vals?.includes(id));
              })
              .map((opt) => opt?.value);
            const prevCatFour = state?.careGroupDetails?.catFourIds || [];
            const keptCatFour = prevCatFour.filter((it) => allowedCat4Ids?.includes(it?.value));

            setState((prev) => ({
              ...prev,
              careGroupDetails: {
                ...prev?.careGroupDetails,
                catOneIds: selected,
                catTwoIds: keptCatTwo,
                catThreeIds: keptCatThree,
                catFourIds: keptCatFour,
              },
            }));
          }
        }
        break;
      case 'catTwoIds':
        {
          const catOneIds = state?.careGroupDetails?.catOneIds?.map((item) => item.value);
          getCategory3Data(catOneIds, selectedIds);
          if (catBasedOnPTData) {
            const prevC2 = state?.careGroupDetails?.catTwoIds || [];
            const prevC2Len = prevC2.length;
            const isAdding = (selectedIds?.length || 0) >= prevC2Len;
            if (isAdding) {
              // Adding Cat2: keep existing Cat3/4 as-is
              setState((prev) => ({
                ...prev,
                careGroupDetails: {
                  ...prev?.careGroupDetails,
                  catTwoIds: selected,
                },
              }));
              break;
            }
            // Removing Cat2: prune Cat3/4 based on new Cat2 selection combined with existing Cat1
            const keptC1Vals = (state?.careGroupDetails?.catOneIds || []).map((k) => k?.value);
            const keptC2Vals = selectedIds || [];

            const allowedCat3Ids = (category3Options || [])
              .filter((opt) => {
                const c1Rel = opt?._raw?.categoryOneId || opt?._raw?.catOneIds || [];
                const c2Rel = opt?._raw?.categoryTwoId || opt?._raw?.catTwoIds || [];
                const a1 = (Array.isArray(c1Rel) ? c1Rel : [c1Rel]).map((r) => r?._id || r).filter(Boolean);
                const a2 = (Array.isArray(c2Rel) ? c2Rel : [c2Rel]).map((r) => r?._id || r).filter(Boolean);
                return a1?.some((id) => keptC1Vals?.includes(id)) && a2?.some((id) => keptC2Vals?.includes(id));
              })
              .map((opt) => opt?.value);
            const prevCatThree = state?.careGroupDetails?.catThreeIds || [];
            const keptCatThree = prevCatThree.filter((it) => allowedCat3Ids?.includes(it?.value));
            const keptC3Vals = keptCatThree.map((k) => k?.value);

            const allowedCat4Ids = (category4Options || [])
              .filter((opt) => {
                const c1Rel = opt?._raw?.categoryOneId || opt?._raw?.catOneIds || [];
                const c2Rel = opt?._raw?.categoryTwoId || opt?._raw?.catTwoIds || [];
                const c3Rel = opt?._raw?.categoryThreeId || opt?._raw?.catThreeIds || [];
                const a1 = (Array.isArray(c1Rel) ? c1Rel : [c1Rel]).map((r) => r?._id || r).filter(Boolean);
                const a2 = (Array.isArray(c2Rel) ? c2Rel : [c2Rel]).map((r) => r?._id || r).filter(Boolean);
                const a3 = (Array.isArray(c3Rel) ? c3Rel : [c3Rel]).map((r) => r?._id || r).filter(Boolean);
                return a1?.some((id) => keptC1Vals?.includes(id)) && a2?.some((id) => keptC2Vals?.includes(id)) && a3?.some((id) => keptC3Vals?.includes(id));
              })
              .map((opt) => opt?.value);
            const prevCatFour = state?.careGroupDetails?.catFourIds || [];
            const keptCatFour = prevCatFour.filter((it) => allowedCat4Ids?.includes(it?.value));

            setState((prev) => ({
              ...prev,
              careGroupDetails: {
                ...prev?.careGroupDetails,
                catTwoIds: selected,
                catThreeIds: keptCatThree,
                catFourIds: keptCatFour,
              },
            }));
          }
        }
        break;
      case 'catThreeIds':
        {
          const catOneIds = state?.careGroupDetails?.catOneIds?.map((item) => item.value);
          const catTwoIds = state?.careGroupDetails?.catTwoIds?.map((item) => item.value);
          getCategory4Data(catOneIds, catTwoIds, selectedIds);
          if (catBasedOnPTData) {
            const prevC3 = state?.careGroupDetails?.catThreeIds || [];
            const prevC3Len = prevC3.length;
            const isAdding = (selectedIds?.length || 0) >= prevC3Len;
            if (isAdding) {
              // Adding Cat3: keep existing Cat4 as-is
              setState((prev) => ({
                ...prev,
                careGroupDetails: {
                  ...prev?.careGroupDetails,
                  catThreeIds: selected,
                },
              }));
              break;
            }
            // Removing Cat3: prune Cat4 based on new Cat3 combined with existing Cat1 & Cat2
            const keptC1Vals = (state?.careGroupDetails?.catOneIds || []).map((k) => k?.value);
            const keptC2Vals = (state?.careGroupDetails?.catTwoIds || []).map((k) => k?.value);
            const keptC3Vals = selectedIds || [];
            const allowedCat4Ids = (category4Options || [])
              .filter((opt) => {
                const c1Rel = opt?._raw?.categoryOneId || opt?._raw?.catOneIds || [];
                const c2Rel = opt?._raw?.categoryTwoId || opt?._raw?.catTwoIds || [];
                const c3Rel = opt?._raw?.categoryThreeId || opt?._raw?.catThreeIds || [];
                const a1 = (Array.isArray(c1Rel) ? c1Rel : [c1Rel]).map((r) => r?._id || r).filter(Boolean);
                const a2 = (Array.isArray(c2Rel) ? c2Rel : [c2Rel]).map((r) => r?._id || r).filter(Boolean);
                const a3 = (Array.isArray(c3Rel) ? c3Rel : [c3Rel]).map((r) => r?._id || r).filter(Boolean);
                return a1?.some((id) => keptC1Vals?.includes(id)) && a2?.some((id) => keptC2Vals?.includes(id)) && a3?.some((id) => keptC3Vals?.includes(id));
              })
              .map((opt) => opt?.value);
            const prevCatFour = state?.careGroupDetails?.catFourIds || [];
            const keptCatFour = prevCatFour.filter((it) => allowedCat4Ids?.includes(it?.value));

            setState((prev) => ({
              ...prev,
              careGroupDetails: {
                ...prev?.careGroupDetails,
                catThreeIds: selected,
                catFourIds: keptCatFour,
              },
            }));
          }
        }
        break;
      default:
        break;
    }
  };

  return (
    <div>
      <div className="page-title-filter sticky">
        <div className="title-container d-flex align-items-center">
          <h4 className="title">
            {groupId ? t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.EDIT_GROUP') : t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.ADD_GROUP')}
          </h4>
        </div>
        <UserLibraryFilter fromCareAddEditGroup showButtons={false} hideShowDragDrop={hideShowDragDrop} />
      </div>
      <Container className="edit-group" fluid>
        <Row className="">
          <Col md="2">
            <div className="common-input-control">
              <p className="field-name">
                {t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.GROUP_NAME')}
                <span className="asterisk">*</span>
              </p>
              <input
                type="text"
                name="name"
                className="form-control p-0"
                placeholder={t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.ENTER_GROUP_NAME')}
                onChange={(e) => handleInput(e?.target?.value, 'name')}
                value={state?.careGroupDetails?.name || ''}
              />
              {state?.careGroupDetails?.error && !state?.careGroupDetails?.name && (
                <p className="error-message">{t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.ENTER_GROUP_NAME')}</p>
              )}
            </div>
          </Col>
          <Col md="2">
            <div className="common-react-select">
              <p className="field-name">
                {t('USER_INSTRUCTION_LIBRARY.COLUMN_MODAL.PRODUCT_TYPE')}
                <span className="asterisk">*</span>
              </p>
              <MultiSelect
                className="product-custom-multiselect common-new-multiselect"
                options={pcTypeOptions || []}
                value={state?.careGroupDetails?.productType || []}
                onChange={(selected) => {
                  handleMultiSelect(selected, 'productType');
                }}
                styles={customStylesProductAddEdit}
                overrideStrings={{
                  selectSomeItems: t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.SELECT_PRODUCT_TYPE'),
                }}
                labelledBy={t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.SELECT_PRODUCT_TYPE')}
              />

              {state?.careGroupDetails?.error && !state?.careGroupDetails?.productType?.length && (
                <p className="mb-0 error-message">{t('SUPPLIER_TO_DO.PRODUCT_TYPE_REQUIRED')}</p>
              )}
            </div>
          </Col>
          <Col md="2">
            <div className="common-react-select">
              <p className="field-name">
                {t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.BRAND')}
                <span className="asterisk">*</span>
              </p>
              <MultiSelect
                className="product-custom-multiselect common-new-multiselect"
                options={brandOptions || []} // ✅ required
                value={state?.careGroupDetails?.brandIds || []} // ✅ avoid undefined
                onChange={(selected) => {
                  handleMultiSelect(selected, 'brandIds');
                }}
                overrideStrings={{
                  selectSomeItems: t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.SELECT_BRAND'),
                }}
                labelledBy={t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.SELECT_BRAND')}
              />

              {state?.careGroupDetails?.error && !state?.careGroupDetails?.brandIds?.length && (
                <p className="mb-0 error-message">{t('SUPPLIER_TO_DO.BRAND_REQUIRED')}</p>
              )}
            </div>
          </Col>
          {subBrandAccess && (
            <Col md="2">
              <div className="common-react-select">
                <p className="field-name">{t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.SUB_BRAND')}</p>
                <MultiSelect
                  className="product-custom-multiselect common-new-multiselect"
                  options={subBrandOptions?.filter((val) => val?.isActive) || []} // ✅ required
                  value={state?.careGroupDetails?.subBrandIds || []} // ✅ avoid undefined
                  onChange={(selected) => {
                    handleMultiSelect(selected, 'subBrandIds');
                  }}
                  overrideStrings={{
                    selectSomeItems: t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.SELECT_SUB_BRAND'),
                  }}
                  labelledBy={t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.SELECT_SUB_BRAND')}
                />
              </div>
            </Col>
          )}
          <Col md="2">
            <div className="common-react-select">
              <p className="field-name">
                {t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.CATEGO0RY_1')}
                <span className="asterisk">*</span>
              </p>
              <MultiSelect
                className="product-custom-multiselect common-new-multiselect"
                options={(catBasedOnPTData ? category1OptionsDerived : category1Options) || []} // ✅ required
                value={state?.careGroupDetails?.catOneIds || []} // ✅ avoid undefined
                onChange={(selected) => {
                  handleMultiSelect(selected, 'catOneIds');
                }}
                overrideStrings={{
                  selectSomeItems: t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.SELECT_CATEGORY_1'),
                }}
                labelledBy={t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.SELECT_CATEGORY_1')}
              />

              {state?.careGroupDetails?.error && !state?.careGroupDetails?.catOneIds?.length && (
                <p className="mb-0 error-message">{t('SUPPLIER_TO_DO.CATEGORY_1_REQUIRED')}</p>
              )}
            </div>
          </Col>
          <Col md="2">
            <div className="common-react-select">
              <p className="field-name">
                {t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.CATEGORIES_2')}
                <span className="asterisk">*</span>
              </p>
              <MultiSelect
                className="product-custom-multiselect common-new-multiselect"
                options={(catBasedOnPTData ? category2OptionsDerived : category2Options) || []} // ✅ required
                value={state?.careGroupDetails?.catTwoIds || []} // ✅ avoid undefined
                onChange={(selected) => {
                  handleMultiSelect(selected, 'catTwoIds');
                }}
                overrideStrings={{
                  selectSomeItems: t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.SELECT_CATEGORY_2'),
                }}
                labelledBy={t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.SELECT_CATEGORY_2')}
              />

              {state?.careGroupDetails?.error && !state?.careGroupDetails?.catTwoIds?.length && (
                <p className="mb-0 error-message">{t('SUPPLIER_TO_DO.CATEGORY_2_REQUIRED')}</p>
              )}
            </div>
          </Col>
          <Col md="2">
            <div className="common-react-select">
              <p className="field-name">{t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.CATEGORIES_3')}</p>
              <MultiSelect
                className="product-custom-multiselect common-new-multiselect"
                options={(catBasedOnPTData ? category3OptionsDerived : category3Options) || []} // ✅ required
                value={state?.careGroupDetails?.catThreeIds || []} // ✅ avoid undefined
                onChange={(selected) => {
                  handleMultiSelect(selected, 'catThreeIds');
                }}
                overrideStrings={{
                  selectSomeItems: t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.SELECT_CATEGORY_3'),
                }}
                labelledBy={t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.SELECT_CATEGORY_3')}
              />
            </div>
          </Col>
          <Col md="2">
            <div className="common-react-select">
              <p className="field-name">{t('COMPONENT.PRODUCT_INFORMATION.PRODUCT_MODAL.CATEGORY4')}</p>
              <MultiSelect
                className="product-custom-multiselect common-new-multiselect"
                options={(catBasedOnPTData ? category4OptionsDerived : category4Options) || []} // ✅ required
                value={state?.careGroupDetails?.catFourIds || []} // ✅ avoid undefined
                onChange={(selected) => {
                  handleMultiSelect(selected, 'catFourIds');
                }}
                overrideStrings={{
                  selectSomeItems: t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.SELECT_CATEGORY_4'),
                }}
                labelledBy={t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.SELECT_CATEGORY_4')}
              />
            </div>
          </Col>
          <Col md="6">
            <div className="d-flex">
              <div className="common-input-control flex-fill">
                <p className="field-name">{t('USER_INSTRUCTION_LIBRARY.COLUMN_MODAL.ADDITIONAL_INFORMATION')}</p>
                <input
                  type="text"
                  name="additonalInformation"
                  className="form-control p-0"
                  placeholder={t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.ENTER_ADDITIONAL_INFORMATION')}
                  onChange={(e) => handleInput(e?.target?.value, 'additonalInformation')}
                  value={state?.careGroupDetails?.additonalInformation || ''}
                />
              </div>
            </div>
          </Col>
          <Col md="2">
            <div className="d-flex switch-container align-items-center">
              <div className="d-flex design-switch">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="isRequired"
                  name="isRequired"
                  checked={state?.careGroupDetails?.isRequired || false}
                  onChange={(e) => handleInput(e?.target?.checked, 'isRequired')}
                />
                <label className="text-nowrap required-title" htmlFor="isRequired">
                  {t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION_GROUP.REQUIRED')}
                </label>
              </div>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md="12">
            <div className="d-flex search-color-lib-container mr-5 mb-4">
              <Typeahead
                ref={typeaheadRef}
                id="typeheadWithColours"
                className="custom-AsyncTypeHead"
                labelKey="code"
                minLength={1}
                options={suggestionList}
                promptText="No Care Details found"
                placeholder={t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.SEARCH_CARE_USER_GROUP')}
                useCache={false}
                filterBy={customFilterBy}
                onChange={(selected) => onAutoSuggestion(selected)}
                renderMenuItemChildren={(option) => (
                  <div className="d-flex" key={option._id}>
                    <div className="list-text">{option?.code ? `${option?.code} - ${option?.description}` : ''}</div>
                  </div>
                )}
              />
            </div>
          </Col>
        </Row>
        {state?.showDragDrop && (
          <DragDropSort
            isShow={state?.showDragDrop}
            itemList={state?.careGroupDetails?.tabs}
            isToggle={hideShowDragDrop}
            saveSequence={handleSaveSequence}
            fromComp="careUserInstructionsGroup"
          />
        )}
        {state?.careGroupDetails?.tabs
          ?.sort((a, b) => a.sequence - b.sequence)
          .map(
            (item, index) =>
              !item?.forDocument && (
                <CommonAccordion key={item?._id || index} item={item} index={index} accordianKey={item?._id} handleExpandKey={index} showButtons />
              ),
          )}
        {state?.showConfirmationPopup && (
          <ConfirmationPopup
            onOpen={state?.showConfirmationPopup}
            toggle={() =>
              setState((prevState) => ({
                ...prevState,
                showConfirmationPopup: false,
                deleteId: '',
                selectedIds: [],
                isSelectAll: false,
              }))
            }
            title={t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.DELETE_GROUP')}
            message={`${t('USER_INSTRUCTION_LIBRARY.USER_INSTRUCTION.MESSAGES')}?`}
          />
        )}
      </Container>
    </div>
  );
}
